import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { selectCurrentTheme } from '../../../flux/selectors/ux'

const StyledRoot = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
}))

const StyledImage = styled.img(() => ({
  maxWidth: '100%',
  maxHeight: '150px',
}))

const CustomHeroSection = ({
  desktop,
  tablet,
  mobile,
  retailerName,
}) => {
  const theme = useSelector(selectCurrentTheme)

  return (
    <StyledRoot>
      <picture>
        <source media={`(min-width: ${theme.breakpoints.medium})`} srcSet={tablet} />
        <source media={`(min-width: ${theme.breakpoints.large})`} srcSet={desktop} />
        <StyledImage src={mobile} alt={`${retailerName} - Custom Hero Image`} />
      </picture>
    </StyledRoot>
  )
}

CustomHeroSection.propTypes = {
  desktop: PropTypes.string,
  tablet: PropTypes.string,
  mobile: PropTypes.string,
  retailerName: PropTypes.string,
}

CustomHeroSection.defaultProps = {
  desktop: null,
  tablet: null,
  mobile: null,
  retailerName: null,
}

CustomHeroSection.displayName = 'CustomHeroSection'
CustomHeroSection.whyDidYouRender = true

export default React.memo(CustomHeroSection)
